import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import store from "./store.js";

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/admin')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/index.html",
      redirect: "/"
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "/login",
      name: "login",
      beforeEnter: ifNotAuthenticated,
      component: () =>
        import("./views/Login.vue")
    },
    {
      path: "/admin",
      redirect: "/admin/questions",
    },
    {
      path: "/admin/questions",
      name: "admin",
      meta: { layout: "admin" },
      props: true,
      beforeEnter: ifAuthenticated,
      component: () =>
        import("./views/AdminQuestions.vue")
    },
    {
      path: "/admin/questions/new",
      name: "AdminNewQuestion",
      meta: { layout: "admin" },
      beforeEnter: ifAuthenticated,
      component: () =>
        import("./views/AdminNewQuestion.vue")
    },
    {
      path: "/admin/questions/:id",
      name: "AdminQuestion",
      meta: { layout: "admin" },
      beforeEnter: ifAuthenticated,
      component: () =>
        import("./views/AdminQuestion.vue")
    },
    {
      path: "/admin/questions/:id/results",
      name: "VotingResults",
      meta: { layout: "admin" },
      beforeEnter: ifAuthenticated,
      component: () =>
        import("./views/VotingResults.vue")
    },
    {
      path: "/voting",
      redirect: "/"
    },
    {
      path: "/voting/:id",
      name: "Voting",
      component: () =>
        import("./views/Voting.vue")
    },
    {
      path: "/voted",
      name: "Voted",
      component: () =>
        import("./views/Voted.vue")
    },
    {
      path: "/terms",
      name: "Terms",
      component: () =>
        import("./views/Terms.vue")
    },
    {
      path: "/contact",
      name: "Contact",
      component: () =>
        import("./views/Contact.vue")
    }
  ]
});
